import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { AuthProvider } from './contexts/AuthContext';
import { CityProvider } from './contexts/CityContext';
import TopBar from './components/TopBar';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Delivery from './pages/Delivery';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <CityProvider>
          <Router>
            <AppContent />
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 2000,
                  iconTheme: {
                    primary: '#22c55e',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </Router>
        </CityProvider>
      </CartProvider>
    </AuthProvider>
  );
}

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    try {
      localStorage.removeItem('proteko-cart');
      localStorage.removeItem('proteko-selected-city');
      localStorage.removeItem('proteko-cookie-notice');
    } catch (error) {
      // localStorage can be unavailable in private browsing modes.
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <TopBar />
      <Header />
      
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/delivery" element={<Delivery />} />
          <Route path="/profile" element={<Navigate to="/" replace />} />
          <Route path="/orders" element={<Navigate to="/" replace />} />
          <Route path="/checkout" element={<Navigate to="/" replace />} />
          <Route path="/order-success/:orderId" element={<Navigate to="/" replace />} />
          <Route path="/personal-data-consent" element={<Navigate to="/privacy" replace />} />
          <Route path="/cookies" element={<Navigate to="/privacy" replace />} />
          <Route path="/offer" element={<Navigate to="/privacy" replace />} />

        </Routes>
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
